import React, { Fragment, useEffect, useState } from 'react';

import { Prompt, withRouter } from 'react-router-dom';
import { RouterHistory } from '@sentry/react/types/reactrouter';

import Modal from '../utils/ModalComponet';

type Props = {
  history: RouterHistory;
  shouldBlockNavigation(nextLocation: Location): boolean;
  when: boolean;
};

const RouteLeavingGuard = ({ history, shouldBlockNavigation, when }: Props) => {
  const [visible, setVisible] = useState(false);

  const [lastLocation, setLastLocation] = useState<Location | null>(null);

  const [confirmedNavigation, setConfirmedNavigation] = useState<boolean>(
    false
  );

  const closeModal = (): void => {
    setVisible(false);
  };

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      setVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = (): void => {
    setVisible(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      history.push(lastLocation.pathname);
    }
  }, [confirmedNavigation, history, lastLocation]);

  return (
    <Fragment>
      <Prompt when={when} message={handleBlockedNavigation} />
      <Modal
        open={visible}
        closeModal={closeModal}
        cancel={closeModal}
        action={handleConfirmNavigationClick}
        actionButtonText='Ok'
      >
        <div style={{ marginBottom: '40px' }}>
          Are you sure you want to leave this page? All changes will be lost
        </div>
      </Modal>
    </Fragment>
  );
};

export default withRouter(RouteLeavingGuard);
